export default __webpack_public_path__ + "workpiece97ffa4.jpg";